<main class="term-container" aria-labelledby="privacy-title" role="main">
  <h1 id="privacy-title" class="visually-hidden">{{'PrivacyPolicy' | translate}}</h1>
  <h3 class="term--subtitle" itemprop="name">{{'PrivacyLastUpdated'| translate}}</h3>
  <div class="term-list" role="list">

    @for (item of privacyModel.items; track item.order) {
    <article class="term-card" role="listitem" itemscope itemtype="https://schema.org/LegalService">
      <h2 class="term-title" itemprop="name">{{item.order}}. {{ item.title }}</h2>
      <div class="term-content" itemprop="description" [innerHTML]="item.content"></div>
    </article>

    }
  </div>

  <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Privacy Policy",
      "hasPart": [
        {{ privacyModel.items.map(i => '{"@type":"CreativeWork","position":'+(i.order)+',"name":"'+(i.title)+'"}') .join(', ') }}
      ]
    }
    </script>
</main>